import React, { useState, useEffect } from "react";
import axios from "../../axios";
import { get } from "lodash";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { connect } from "react-redux";
import * as actionTypes from "../../store/actions";
import moment from "moment";
import { Field, Form, Formik } from "formik";
import "./Gigs.css";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import { bottom } from "@popperjs/core";
import dummyProfile from "../../assets/images/lady.png";
import { TiInfoLarge } from "react-icons/ti";

import Input from "../../components/Input";
import { Modal } from "../../components/Modal";
import Overlay from "../../components/Overlay";
import TextArea from "../../components/TextArea";
import ReactReadMoreReadLess from "react-read-more-read-less";
import Verified from "../../assets/images/verification.png";

import {
  extractDate,
  extractOnlyDate,
  extractOnlyMonthYear,
  getFileSize,
  maskToken,
  maskSocialSecurityNumber,
  uploadImage,
  subadminAccessChange,
} from "../../utils/functions";

// Mui & material UI
import Stack from "@mui/material/Stack";
import Switch from "@mui/material/Switch";
import { styled } from "@mui/material/styles";
import Checkbox from '@mui/material/Checkbox';
import SearchBar from "material-ui-search-bar";
import FormGroup from "@mui/material/FormGroup";
import Typography from "@mui/material/Typography";
import Pagination from "@mui/material/Pagination";
import { makeStyles } from "@material-ui/core/styles";
import FormControlLabel from "@mui/material/FormControlLabel";
import PaginationItem from '@mui/material/PaginationItem';

import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
} from "@material-ui/core";
import { TextField, Popover, Box } from "@mui/material";

// icons
import { FaRegUser } from "react-icons/fa";
import { IoIosLink } from "react-icons/io";
import { IoCallOutline } from "react-icons/io5";
import { IoLocationOutline } from "react-icons/io5";
import { AiOutlineMail } from "react-icons/ai";
import { LuContact } from "react-icons/lu";
import { GoCalendar } from "react-icons/go";
import { SlPencil } from "react-icons/sl";
import { HiMiniArrowLeft, HiMiniArrowRight } from "react-icons/hi2";
import { PiAndroidLogoFill } from "react-icons/pi";
import { MdOutlineFileDownload } from "react-icons/md";

import unblock from "../../assets/images/unblock.png";
import block from "../../assets/images/block.png";
import medal from "../../assets/images/medal.png";

import { SlClose } from "react-icons/sl";
import { RxCross2 } from "react-icons/rx";
import { FaArrowLeft } from "react-icons/fa";
import { IoIosLogOut } from "react-icons/io";
import { TiInfoOutline, TiTick } from "react-icons/ti";
import { BiSolidPackage } from "react-icons/bi";
import { RxCrossCircled } from "react-icons/rx";
import { HiArrowNarrowLeft } from "react-icons/hi";
import { GrApple, GrAndroid } from "react-icons/gr";
import { BsDot, BsEyeFill, BsPlus, BsThreeDotsVertical } from "react-icons/bs";
import { PiHandsClappingBold, PiUserList, PiXCircleFill } from "react-icons/pi";

import JPG from "../../assets/images/jpg.png";
import placeholder from "../../assets/images/placeholder.jpg";
import Pdf from "../../assets/images/Pdf.png";
import certificate from "../../assets/images/ApproveCertificate.png";

import {
  MdBlock,
  MdClose,
  MdEmail,
  MdLocalPhone,
  MdPhone,
} from "react-icons/md";
import {
  IoArchive,
  IoArrowBackCircleOutline,
  IoArrowForwardCircleOutline,
} from "react-icons/io5";
import {
  FaFilter,
  FaGlobe,
  FaPhone,
  FaUser,
  FaUserAlt,
  FaMoneyBill,
  FaCheckCircle,
} from "react-icons/fa";

// Elements
import {
  DashboardContainer,
  DashboardWrapper,
  DashboardHeading,
  ProfileDetailForm,
  ServiceDetailForm,
  DashHeading,
  Button,
  Filter,
  DpBox,
  Fields,
  Resetbtn,
  Applybtn,
} from "./GigsManagementElement";
import FileSizeDisplay from "../../components/FileSize";
import { RiOverline } from "react-icons/ri";

import Star from "../../assets/images/star.png"
import Fire from "../../assets/images/fair.png"
import Check from "../../assets/images/checkcircle.gif"


const useStyles = makeStyles((theme) => ({
  table: {
    borderCollapse: 'separate',
    borderSpacing: '0 10px', // adds vertical spacing between rows
  },
  paperTableHeight: {
    width: "97%",
    marginLeft: "1rem",
    minHeight: "40vh",
    border: "1px solid rgba(12, 45, 6, 0.10)",
    borderRadius: "10px",
    overflow: "scroll",
  },
  tableMainContainer: {
    maxHeight: "50vh",
    overflowX: "auto",
    overflowY: "auto",
    borderTopLeftRadius: "4px",
    borderTopRightRadius: "4px",
  },
  tableHeadingRow: {
    position: "sticky", // Make header sticky
    top: 0, // Stick to the top
    zIndex: 1, // Ensure it appears above other rows
    background: "#FFFFFF", // Header background color
    border: "1px solid rgba(17, 153, 38, 0.20)",

  },
  tableBodyRow: {
    background: "#FFFFFF",
    border: "1px solid rgba(17, 153, 38, 0.20)",

    "&:hover": {
      backgroundColor: "#f5f5f5",
    },
  },
  tableHeadingCell: {
    // padding: "0.5rem 1rem !important",
    textAlign: "center",
    fontSize: "14px",
    color: "#1C2D28",
    fontWeight: "500",
    // border: "1px solid #D9E3D9",
    whiteSpace: "nowrap",
    background: "#FFFFFF",
    border: "none"
  },
  textMiddle: {
    // padding: "0.4rem 1rem !important",
    verticalAlign: "middle !important",
    textAlign: "center",
    fontSize: "14px",
    color: "#484848",
    fontFamily: "Roboto",
    fontWeight: "400",
    background: "#FFFFFF",
    border: "none"
  },
  tablePaginationStyle: {
    borderTop: "1px solid #0000001a",
    borderRadius: "0rem 0rem 0.4rem 0.4rem",
    overflowY: "hidden",
  },
  paginationContainer: {
    marginTop: "2rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }
}));





const GigOverview = ({ setUsers, userData }) => {
  const adminData = JSON.parse(localStorage.getItem("userData") || userData || sessionStorage.getItem("userData"));

  const userManagementPermissions = adminData?.adminpermissions?.modules?.find(
    (module) => module.moduleName === "User Management"
  )?.permissions || {};

  const canDelete = !!userManagementPermissions.delete;

  const param = useParams();
  const location = useLocation();
  const classes = useStyles();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [userDetails, setUserDetails] = useState();
  const [userCount, setUserCount] = useState();

  const [skillsDetails, setSkillsDetails] = useState();
  const [userCertificate, setUserCertificate] = useState([])
  const [invitationData, setInvitationData] = useState([])
  const [userInfo, setUserInfo] = useState([])
  const [userInfoData, setUserInfoData] = useState([])
  const [statusData, setStatusData] = useState(false)
  const [statusHistryData, setStatusHistryData] = useState([])
  const [hiredDetailsData, setHiredDetailsData] = useState([])


  const [rejectionReason, setRejectionReason] = useState("");
  const [certificateId, setCertificateId] = useState(null);

  const [blockModal, setBlockModal] = useState(false);
  const [unBlockModal, setUnBlockModal] = useState(false);
  const [description, setDescription] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  const [paymentModal, setPaymentModal] = useState(false);



  const [deleteModal, setDeleteModal] = useState(false);
  const [approvedCertificate, setApprovedCertificate] = useState(false);
  const [rejectCertificate, setRejectCertificate] = useState(false);
  const [reasonDeleteModal, setReasonDeleteModal] = useState(false);
  const [actionType, setActionType] = useState(""); // "accept" or "reject"
  const [showRejectionReason, setShowRejectionReason] = useState(false);
  const [showTable, setShowTable] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [profileChecked, setProfileChecked] = useState(false);
  const [documentChecked, setDocumentChecked] = useState(false);
  const [profileReason, setProfileReason] = useState("");
  const [documentReason, setDocumentReason] = useState("");
  const [filterStatus, setFilterStatus] = useState("overview")

  const [userHistory, setUserHistory] = useState();

  const [anchorEl, setAnchorEl] = useState(null);


  const handleFilterClick = (event) => {
    setAnchorEl(event.currentTarget); // Open the filter popover
  };

  const handleClose = () => {
    setAnchorEl(null); // Only close the popover without resetting
  };

  const open = Boolean(anchorEl);
  const id = open ? "filter-popover" : undefined;



  // For Pagination
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalDocs, setTotalDocs] = useState(0);

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(1); // Reset to the first page when rows per page change
  };

  const handleChangePage = (event, newPage) => {
    // handleCancel();
    setPage(newPage); // Update page and trigger data fetch
  };

  const [verificationDocumentModal, setVerificationDocumentModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(""); // Store clicked image source

  const handleImageClick = (imageSrc) => {
    setSelectedImage(imageSrc);
    setVerificationDocumentModal(true);
  };




  // For Select checkbox
  const [selectedRows, setSelectedRows] = useState([]);

  useEffect(() => {
    if (tableData.length === 0) {
      setSelectedRows([]);
    }
  }, [tableData]);

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      setSelectedRows(tableData.map((item) => item._id));
    } else {
      setSelectedRows([]);
    }
  };

  const handleSelectRow = (id) => {
    const newSelectedRows = selectedRows.includes(id)
      ? selectedRows.filter((rowId) => rowId !== id)
      : [...selectedRows, id];
    setSelectedRows(newSelectedRows);
  };

  const handleClearSelection = () => {
    setSelectedRows([]);
  };


  //  this is for open history
  const handleClick = () => {
    setShowTable(!showTable);
  };





  // Get user Gig detail data
  useEffect(() => {
    getUserGigsDetails();

  }, [filterStatus]);

  const getUserGigsDetails = async () => {
    setIsLoading(true);

    try {
      const { data } = await axios.post(`/private/getUserGigsDetails/${param?.id}`, {
        hostPage: String(filterStatus),  //"overview","invitation","hire",
      });

      console.log("getUserGigsDetails", data)
      const obj = JSON.parse(data?.data?.gigPaymentSummary);
      console.log("getUserGigsDetails1", typeof obj)
      if (typeof data?.data?.gigPaymentSummary === "string") {
        data.data.gigPaymentSummary = JSON.parse(data.data.gigPaymentSummary);

      }


      setUserCount(data);
      setUserDetails(data?.data);
      setSkillsDetails(data?.data?.skillRequired)
      setUserCertificate(data?.data?.certificatesData)
      setInvitationData(data?.proposalDetails?.docs)
      setUserInfo(data?.proposalDetails?.docs)
      setUserInfoData(data?.proposalDetails?.docs)

      setStatusHistryData(data?.proposalDetails?.docs[0]?.invitationHistory)

      setHiredDetailsData(data?.hiredDetails?.docs)


    } catch (error) {
      if (error?.response?.status === 901) {
        subadminAccessChange(navigate);
        toast.error(`${error.response.data?.message}`, {
          position: "top-right",
        });
      } else if (error?.response?.status === 419) {
        localStorage.clear();
        Cookies.remove("showProfileSidebar");
        setUsers("");

        toast.error(`${error.response.data?.message}`, {
          position: "top-right",
        });

        navigate("/");
      } else {
        console.log("error", error?.response);
      }
    } finally {
      setIsLoading(false);
    }
  };


  // Block unblock functionality
  const blockUnblock = async () => {
    try {
      const response = await axios.put(`/private/gigs/blockUnBlock/${param?.id}`);

      toast.success(response.data.message, {
        position: "top-right",
      });
      getUserGigsDetails(page);
    } catch (error) {

      if (error.response?.status === 419) {
        localStorage.clear();
        Cookies.remove("showProfileSidebar");
        toast.error(error.response.data?.message, {
          position: "top-right",
        });
        navigate("/");
      } else {
        toast.error("Something went wrong", {
          position: "top-right",
        });
      }
    }
  };


  const payment = async () => {
  try {
    const response = await axios.get(`/private/payoutByAdmin/${userDetails.invitationDetails._id}`);

    toast.success(response.data.message, {
      position: "top-right",
    });

    setPaymentModal(true);   //  modal open yaha hoga

    getUserGigsDetails(page);
  } catch (error) {
    if (error.response?.status === 419) {
      localStorage.clear();
      Cookies.remove("showProfileSidebar");
      toast.error(error.response.data?.message, {
        position: "top-right",
      });
      navigate("/");
    } else {
      toast.error("Something went wrong", {
        position: "top-right",
      });
    }
  }
};





  const download = async (data) => {
    try {
      const link = document.createElement('a');
      link.href = data; // 'data' should be a URL or Blob URL
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Download failed:", error);
    }
  };

  const downloadCertificate = async (data) => {
    try {
      const link = document.createElement('a');
      link.href = data; // 'data' should be a URL or Blob URL
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Download failed:", error);
    }
  };


  const backRoute =
    location.state?.from === "gigsManagement"
      ? "/gigsManagement"
      : location.state?.from === "reportedGigManagement"
        ? "/reportedGigManagement"
        : location.state?.from === "paymentManagement"
          ? "/paymentManagement"
          : "/dashboard";





  return (
    <>
      <DashboardContainer>
        <DashboardWrapper>
          <ProfileDetailForm style={{ gap: "1rem" }}>

            {/* heading */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                cursor: "pointer"
              }}
            >
              <div
                onClick={() => navigate(backRoute)}
              >
                <HiArrowNarrowLeft style={{ fontSize: "1.2rem" }} />
                <span className="common-heading ps-2" style={{ textTransform: 'capitalize' }}>{userDetails?.gigUserType} Gig Overview</span>
              </div>

            </div>


            {/* Bio Data */}
            <div className="userDetailsdataa">
              <div className="user_card_1">
                <div className="text_info_data">
                  <div className="common-heading ">{userDetails?.gigTitle}</div>
                  <div style={{ display: 'flex', gap: "10px" }}>
                    <SlPencil className="user_icons" style={{ marginTop: "8px" }} />
                    <p
                      style={{
                        display: "flex",
                        gap: "1rem",
                        color: "#484848",
                        fontWeight: "400",
                        fontSize: "16px",
                        overflowWrap: "anywhere",
                        marginTop: "8px"

                      }}>{userDetails?.gigDescription}</p>
                  </div>
                </div>

              </div>
              <div className="biodata" style={{ display: "-ms-grid", justifyItems: "end" }}>

                <div style={{ display: "flex", gap: "1rem" }}>

                  {userDetails?.isBlocked === false ? (
                    <button
                      onClick={() => {
                        setBlockModal(true);
                      }}
                    >
                      Block Gig
                    </button>
                  ) : (
                    <button
                      onClick={() => {
                        setUnBlockModal(true);
                      }}
                    >
                      Unblock Gig
                    </button>
                  )}

                  <div className="reported_Count"
                    onClick={() => navigate(`/reportUserList/${userDetails?._id}`, { state: { from: "reportedGigManagement" } })}
                  >
                    Reported Count - {userCount?.reportedCount} <span style={{ textDecoration: "underline", color: "#FFFFFF" }}>View All</span>
                  </div>

                </div>

                <div className="details_data_details">
                  <div className="main_user">
                    <AiOutlineMail className="user_icons" />
                    <span
                      style={{
                        color: "#2960C0",
                        fontWeight: 400,
                        fontSize: "14px",
                        fontFamily: "Roboto",
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                        display: "inline-block",
                        maxWidth: "12rem",
                        verticalAlign: "middle",
                      }}
                      title={userDetails?.postgigDetails?.email ?? "N/A"}
                    >
                      {userDetails?.postgigDetails?.email ?? "N/A"}
                    </span>
                  </div>

                  <div className="main_user">
                    <IoCallOutline className="user_icons" />
                    <span
                      style={{
                        color: "#000000",
                        fontWeight: 400,
                        fontSize: "14px",
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                        display: "inline-block",
                        maxWidth: "12rem",
                        verticalAlign: "middle",
                      }}
                      title={`${userDetails?.postgigDetails?.countryCode ?? ""} ${userDetails?.postgigDetails?.phoneNumber ?? "N/A"}`}
                    >
                      {userDetails?.postgigDetails?.countryCode} {userDetails?.postgigDetails?.phoneNumber ?? "N/A"}
                    </span>
                  </div>

                  <div className="main_user">
                    <FaRegUser className="user_icons" />
                    <span
                      style={{
                        color: "#2960C0",
                        fontWeight: 400,
                        fontSize: "14px",
                        fontFamily: "Roboto",
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                        display: "inline-block",
                        maxWidth: "12rem",
                        verticalAlign: "middle",
                      }}
                      title={`${userDetails?.postgigDetails?.firstName ?? ""} ${userDetails?.postgigDetails?.lastName ?? ""}`}
                    >
                      {userDetails?.postgigDetails?.firstName} {userDetails?.postgigDetails?.lastName}
                    </span>
                  </div>

                </div>
              </div>
            </div>

            {/* Host Data */}
            {userDetails?.gigUserType === "host" && (

              <div className="host-Data">
                <div className="grid-container">
                  <div className="paymentStatusDetails">
                    <div>
                      <div className="paymentDetailHeading">Worker Details</div>
                      <div style={{ display: "flex", flexDirection: "column", gap: "0.5rem", marginTop: "10px" }}>
                        <div className="paymentNameData">{userDetails?.workerDetails?.userName || "N/A"}</div>
                        <div className="MobilePayment">{userDetails?.workerDetails?.countryCode} {userDetails?.workerDetails?.phoneNumber || "N/A"}</div>
                        <div className="MobilePayment">{userDetails?.workerDetails?.email || "N/A"}</div>
                      </div>
                    </div>
                    <div>
                      <div className="paymentDetailHeading">Host Details</div>
                      <div style={{ display: "flex", flexDirection: "column", gap: "0.5rem", marginTop: "10px" }}>
                        <div className="paymentNameData">{userDetails?.hostDetails?.userName || "N/A"}</div>
                        <div className="MobilePayment">{userDetails?.hostDetails?.countryCode} {userDetails?.hostDetails?.phoneNumber || "N/A"}</div>
                        <div className="MobilePayment">{userDetails?.hostDetails?.email || "N/A"}</div>
                      </div>
                    </div>
                    <div>
                      <div className="paymentDetailHeading">Gig Details</div>
                      <div style={{ display: "flex", flexDirection: "column", gap: "0.5rem", marginTop: "10px" }}>
                        <div>
                          <div className="gigHeadingDatadate">Gig Start Date</div>
                          <div className="datePaymentData">{extractOnlyDate(userDetails?.startDate)}</div>
                        </div>
                        <div>
                          <div className="gigHeadingDatadate">Gig End Date</div>
                          <div className="datePaymentData">{extractOnlyDate(userDetails?.endDate)}</div>
                        </div>

                      </div>
                    </div>
                    <div>
                      <div className="paymentDetailHeading">Payment Details</div>

                      {userDetails?.payoutTransactionDetails?.status === "failed" ? (
                        <div style={{ display: "flex", flexDirection: "column", gap: "0.5rem", marginTop: "10px" }}>
                          <div>
                            <div className="gigHeadingDatadate">Amount Paid Date</div>
                            <div className="datePaymentData">
                              {extractOnlyDate(userDetails?.payoutTransactionDetails?.createdAt)}
                            </div>
                          </div>
                          <div>
                            <div className="gigHeadingDatadate">Amount Paid by Host</div>
                            <div style={{
                              background: "#FFCDCD",
                               padding: "0.3rem 1rem", 
                               width: "5rem", 
                               alignContent: "center",
                               color: "#CD1111",
                               fontWeight: 700,
                               fontSize: "18px",
                               fontStyle: "bold",
                               borderRadius: "8px"
                               }}>
                              {userDetails?.payoutTransactionDetails?.amount
                                ? `$ ${userDetails.payoutTransactionDetails.amount}`
                                : "N/A"}
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div style={{ display: "flex", flexDirection: "column", gap: "0.5rem", marginTop: "10px" }}>
                          <div>
                            <div className="gigHeadingDatadate">Amount Paid Date</div>
                            <div className="datePaymentData">
                              {extractOnlyDate(userDetails?.transactionDetails?.createdAt)}
                            </div>
                          </div>
                          <div>
                            <div className="gigHeadingDatadate">Amount Paid by Host</div>
                            <div className="datePaymentData">
                              {userDetails?.transactionDetails?.amount
                                ? `$ ${userDetails.transactionDetails.amount}`
                                : "N/A"}
                            </div>
                          </div>
                          <div>
                            <div className="gigHeadingDatadate">Amount Transferred to Worker</div>
                            <div className="datePaymentData">
                              {userDetails?.transactionDetails?.gigAmount
                                ? `$ ${userDetails.transactionDetails.gigAmount}`
                                : "N/A"}
                            </div>
                          </div>
                          <div>
                            <div className="gigHeadingDatadate">Admin Commission Retained</div>
                            <div className="datePaymentData">
                              {userDetails?.transactionDetails?.adminCommission
                                ? `$ ${userDetails.transactionDetails.adminCommission}`
                                : "N/A"}
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                    <div>
                      {userDetails?.payoutTransactionDetails?.status === "failed" && (
                        <div  onClick={payment} 
                         style={{
                          background: "#5088FB",
                          borderRadius: "4px",
                          color: "#FFFFFF",
                          fontSize: "20px",
                          fontWeight: 500,
                          cursor: "pointer",
                          padding: "0.3rem 1rem",
                        }}>Pay Now</div>
                      )}
                    </div>

                  </div>
                </div>
              </div>
            )}


            {/* Button Section */}
            <div className="nav_button_Gig">
              <div style={{ display: "flex", justifyContent: "space-between", width: "30rem", }}>
                <div className={`nav_button_text  ${filterStatus == "overview" ? 'active' : ''
                  }`}
                  onClick={() => {
                    setFilterStatus("overview");
                  }}
                >
                  Overview</div>
                {userDetails?.gigUserType == "worker" && (
                  <div className={`nav_button_text ${filterStatus == "invitation" ? 'active' : ''
                    }`}
                    onClick={() => {
                      setFilterStatus("invitation");
                    }}
                  >
                    Invitations</div>
                )}
                {userDetails?.gigUserType == "host" && (
                  <div className={`nav_button_text ${filterStatus == "invitation" ? 'active' : ''
                    }`}
                    onClick={() => {
                      setFilterStatus("invitation");
                    }}
                  >
                    Proposals</div>
                )}
                <div className={`nav_button_text ${filterStatus == "hire" ? 'active' : ''
                  }`}
                  onClick={() => {
                    setFilterStatus("hire");
                  }}
                >
                  Hired</div>
              </div>
            </div>


            {/* overview Content Data     */}
            {filterStatus == "overview" && (
              <div style={{ display: "flex", gap: "1rem" }}>

                {/* Worker Gig Details  */}
                {userDetails?.gigUserType === "worker" && (
                  <div>
                    <p className="info_hadding">Gig Details</p>
                    <div className="user-data" style={{ height: "220px" }}>
                      <p className="info_border">Pay Type <span style={{ textTransform: 'capitalize' }}>{userDetails?.gigPayType || "N/A"}</span></p>
                      <p className="info_border">Start Date <span>{extractOnlyDate(userDetails?.startDate)}</span></p>
                      <p className="info_border">Gig Type <span style={{ textTransform: 'capitalize' }}>{userDetails?.gigType || "N/A"}</span></p>
                      <p className="info_border" >Experience
                        <span>
                          {userDetails?.totalExperience
                            ? Math.floor(userDetails.totalExperience / 12) > 0
                              ? `${Math.floor(userDetails.totalExperience / 12)} year${Math.floor(userDetails.totalExperience / 12) !== 1 ? 's' : ''} 
                       ${userDetails.totalExperience % 12} month${userDetails.totalExperience % 12 !== 1 ? 's' : ''}`
                              : `${userDetails.totalExperience % 12} month${userDetails.totalExperience % 12 !== 1 ? 's' : ''}`
                            : 'N/A'}
                        </span>
                      </p>
                      <p className="info_border" style={{ border: "none" }}>Zip Code <span>{userDetails?.zipCode || "N/A"}</span></p>
                    </div>
                  </div>
                )}

                {/* host Gig Details  */}
                {userDetails?.gigUserType === "host" && (
                  <div>
                    <p className="info_hadding">Gig Details</p>
                    <div className="user-data" style={{
                      height: userDetails?.contractGigAmount ? "270px" : "305px"
                    }}>
                      <p className="info_border">Pay Type <span style={{ textTransform: 'capitalize' }}>{userDetails?.gigPayType || "---"}</span></p>
                      <p className="info_border">Start Date <span>{extractOnlyDate(userDetails?.startDate)}</span></p>
                      <p className="info_border">End Date <span>{extractOnlyDate(userDetails?.endDate)}</span></p>
                      {userDetails?.contractGigAmount ? (
                        <p className="info_border">
                          Contract Gig Amount ($)
                          <span> {userDetails.contractGigAmount}</span>
                        </p>
                      ) : (
                        <>
                          <p className="info_border">
                            Hourly Amount <span>${userDetails?.hourlyAmount || "---"}</span>
                          </p>
                          <p className="info_border">
                            Gig Hours <span>{userDetails?.totalGigHrsRequire || "---"}</span>
                          </p>
                        </>
                      )}

                      <p className="info_border">Gig Type <span style={{ textTransform: 'capitalize' }}>{userDetails?.gigType || "---"}</span></p>
                      <p className="info_border" style={{ border: "none" }}>Zip Code <span>{userDetails?.zipCode || "---"}</span></p>
                    </div>
                  </div>
                )}

                <div style={{ width: "100%" }}>
                  <p className="info_hadding">Skills</p>
                  <div className="SkillData">
                    <div style={{ display: "flex", gap: "0.5rem", flexWrap: "wrap" }}>
                      {skillsDetails?.length > 0 ? (
                        skillsDetails.map((skill, index) => (
                          <div className="skill-item-Data" key={index}>{skill}</div>
                        ))
                      ) : (
                        <p>No skills available</p>
                      )}
                    </div>
                  </div>


                  {/* Certificate data only Worker */}
                  {userDetails?.gigUserType === "worker" && (
                    <>
                      <div className="info_hadding" style={{ marginTop: "1rem", marginBottom: "0.5rem" }}>Certificate</div>

                      <div style={{ display: "flex", flexDirection: "column", gap: "0.8rem" }}>
                        {userCertificate && userCertificate.length > 0 ? (
                          // Chunk the array into rows of 3
                          [...Array(Math.ceil(userCertificate.length / 3))].map((_, rowIndex) => (
                            <div style={{ display: "flex", }} key={rowIndex}>
                              {userCertificate
                                .slice(rowIndex * 3, rowIndex * 3 + 3)
                                .map((certificate, index) => (
                                  <div className="certificate-item-Data" key={index}>
                                    <div>
                                      <img
                                        src={certificate.uploadCertificate}
                                        style={{ height: "5rem", width: "7rem" }}
                                      />
                                    </div>
                                    <div>
                                      <p className="certificatetextName">{certificate.certificateName}</p>
                                      <p className="certificatetextNameissueBy">{certificate.issueBy}</p>
                                    </div>
                                  </div>
                                ))}
                            </div>
                          ))
                        ) : (
                          <p>No certificate available</p>
                        )}
                      </div>
                    </>
                  )}

                </div>
              </div>
            )}


            {/* invitation && Praposal Content Data     */}
            {filterStatus == "invitation" && (
              <TableContainer className={classes.tableMainContainer}>
                <Table className={classes.table}>
                  <TableHead>
                    <TableRow className={classes.tableHeadingRow}>
                      <TableCell className={classes.tableHeadingCell}>S.No</TableCell>
                      <TableCell className={classes.tableHeadingCell}>Status</TableCell>
                      <TableCell className={classes.tableHeadingCell}>Sender ID</TableCell>
                      <TableCell className={classes.tableHeadingCell}>Sender Name</TableCell>
                      <TableCell className={classes.tableHeadingCell}>Streak</TableCell>
                      <TableCell className={classes.tableHeadingCell}>Rating</TableCell>
                      <TableCell className={classes.tableHeadingCell}>Invitation Description</TableCell>
                      <TableCell className={classes.tableHeadingCell}>Email Address</TableCell>
                      <TableCell className={classes.tableHeadingCell}>Zip Code</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {invitationData?.length > 0 ? (
                      invitationData.map((user, index) => (
                        <TableRow className={classes.tableBodyRow} key={user._id}>
                          <TableCell className={classes.textMiddle}>
                            {index + 1 + rowsPerPage * (page - 1)}
                          </TableCell>
                          <TableCell className={classes.textMiddle}>
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "0.3rem" }}>
                              <div
                                style={{
                                  fontFamily: "Roboto",
                                  fontWeight: "400",
                                  fontSize: "14px",
                                  padding: "5px 16px",
                                  borderRadius: "31px",
                                  textTransform: "capitalize",
                                  color:
                                    get(user, "invitationHistory[0].statusNo") === "1"
                                      ? "#2CA63F"
                                      : get(user, "invitationHistory[0].statusNo") === "4" ||
                                        get(user, "invitationHistory[0].statusNo") === "6"
                                        ? "#FB5050"
                                        : get(user, "invitationHistory[0].statusNo") === "3"
                                          ? "#FDA517"
                                          : get(user, "invitationHistory[0].statusNo") === "2"
                                            ? "#FDA517"
                                            : get(user, "invitationHistory[0].statusNo") === "5"
                                              ? "#D2A800"
                                              : get(user, "invitationHistory[0].statusNo") === "7"
                                                ? "#5088FB"
                                                : get(user, "invitationHistory[0].statusNo") === "8"
                                                  ? "#D2A800"
                                                  : get(user, "invitationHistory[0].statusNo") === "9"
                                                    ? "#2CA63F"
                                                    : "inherit",
                                  backgroundColor:
                                    get(user, "invitationHistory[0].statusNo") === "1"
                                      ? "#EAFFED"
                                      : get(user, "invitationHistory[0].statusNo") === "4" ||
                                        get(user, "invitationHistory[0].statusNo") === "6"
                                        ? "#FFEBED"
                                        : get(user, "invitationHistory[0].statusNo") === "3"
                                          ? "#FFF3E3"
                                          : get(user, "invitationHistory[0].statusNo") === "2"
                                            ? "#FFF3E3"
                                            : get(user, "invitationHistory[0].statusNo") === "5"
                                              ? "#FFFEE3"
                                              : get(user, "invitationHistory[0].statusNo") === "7"
                                                ? "#F3F3FF"
                                                : get(user, "invitationHistory[0].statusNo") === "8"
                                                  ? "#FFFEE3"
                                                  : get(user, "invitationHistory[0].statusNo") === "9"
                                                    ? "#EAFFED"
                                                    : "transparent",
                                }}
                              >
                                {get(user, "invitationHistory[0].status", "---")}
                              </div>
                              <div>
                                <TiInfoLarge
                                  style={{
                                    backgroundColor: "#5088FB",
                                    color: "#FFFFFF",
                                    fontSize: "0.8rem",
                                    cursor: "pointer",
                                    borderRadius: "1rem",
                                  }}
                                  onClick={() => {
                                    setSelectedUser(user);
                                    setStatusHistryData(user?.invitationHistory || []);
                                    setStatusData(true);
                                  }}
                                />
                              </div>
                            </div>
                          </TableCell>
                          <TableCell className={classes.textMiddle}>
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "0.3rem" }}>
                              <div>
                                {"0000" +
                                  (get(user, "gigUserType") === "host"
                                    ? get(user, "workerDetails.userId", "---")
                                    : get(user, "gigUserType") === "worker"
                                      ? get(user, "hostDetails.userId", "---")
                                      : "---")}
                              </div>

                              <div>
                                <TiInfoLarge
                                  style={{
                                    backgroundColor: "#5088FB",
                                    color: "#FFFFFF",
                                    fontSize: "0.8rem",
                                    cursor: "pointer",
                                    borderRadius: "1rem",
                                  }}
                                  onClick={(e) => {
                                    setUserInfo(user);
                                    handleFilterClick(e)
                                  }}
                                />
                              </div>
                            </div>
                          </TableCell>
                          <TableCell className={classes.textMiddle}>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: "0.5rem"
                              }}
                            >
                              <div>
                                <img src={medal} style={{ height: "1.5rem" }} />
                              </div>
                              <div style={{ textDecoration: "underline", color: "#5088FB" }}>
                                {get(user, "gigUserType") === "host"
                                  ? `${get(user, "workerDetails.firstName", "---")} ${get(user, "workerDetails.lastName", "")}`
                                  : get(user, "gigUserType") === "worker"
                                    ? `${get(user, "hostDetails.firstName", "---")} ${get(user, "hostDetails.lastName", "")}`
                                    : "Unknown"}
                              </div>
                            </div>
                          </TableCell>
                          <TableCell className={classes.textMiddle}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center"
                            }}>
                            <div className="container-Leader">
                              <img src={Fire} className="fire-img-Leader" />
                              <div className="center-text-Leader">
                                {user?.gigUserType === "host" && (
                                  <>
                                    {get(user, "workerStreakDetails.streakCount", "0")}
                                  </>
                                )}

                                {user?.gigUserType === "worker" && (
                                  <>
                                    {get(user, "hostStreakDetails.streakCount", "0")}
                                  </>
                                )}
                              </div>
                            </div>
                          </TableCell>
                          <TableCell className={classes.textMiddle}>
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                              <div style={{
                                width: "41px",
                                height: "21px",
                                background: "#FFF4E7",
                                border: "0.75px solid #0000001F",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: "2px",
                                padding: "10px"

                              }}>


                                {get(user, "gigUserType") === "host"
                                  ? get(user, "workerDetails.averageRating")
                                    ? (Math.floor(Number(get(user, "workerDetails.averageRating")) * 10) / 10).toFixed(1)
                                    : "---"
                                  : get(user, "gigUserType") === "worker"
                                    ? get(user, "hostDetails.averageRating")
                                      ? (Math.floor(Number(get(user, "hostDetails.averageRating")) * 10) / 10).toFixed(1)
                                      : "---"
                                    : "---"}
                                <img src={Star} />

                              </div>
                            </div>
                          </TableCell>
                          <TableCell className={classes.textMiddle}>
                            <div>
                              {get(user, "invitationMsg", "---").length > 30
                                ? `${get(user, "invitationMsg", "---").slice(0, 30)}...`
                                : get(user, "invitationMsg", "---")}
                              <span style={{
                                color: "#29A4CA",
                                cursor: "pointer",
                                textDecoration: "underline"
                              }}
                                onClick={() => {
                                  setSelectedUser(user); // set clicked user
                                  setDescription(true);
                                }}
                              >more</span>
                            </div>
                          </TableCell>
                          <TableCell className={classes.textMiddle}>
                            {get(user, "gigUserType") === "host"
                              ? get(user, "workerDetails.email", "---")
                              : get(user, "gigUserType") === "worker"
                                ? get(user, "hostDetails.email", "---")
                                : "---"}
                          </TableCell>
                          <TableCell className={classes.textMiddle}>
                            {get(user, "gigUserType") === "host"
                              ? get(user, "workerDetails.zipCode", "---")
                              : get(user, "gigUserType") === "worker"
                                ? get(user, "hostDetails.zipCode", "---")
                                : "---"}
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={9} align="center" style={{ padding: "2rem" }}>
                          <DashHeading style={{ textAlign: "center", color: "#000" }}>
                            No Data Found !!
                          </DashHeading>
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            )}


            {/* hire Content Data     */}
            {filterStatus == "hire" && (
              <TableContainer className={classes.tableMainContainer}>
                <Table className={classes.table}>
                  <TableHead>
                    <TableRow className={classes.tableHeadingRow}>
                      <TableCell className={classes.tableHeadingCell}>S.No</TableCell>
                      <TableCell className={classes.tableHeadingCell}>Status</TableCell>
                      <TableCell className={classes.tableHeadingCell}>Hired On</TableCell>
                      <TableCell className={classes.tableHeadingCell}>User ID</TableCell>
                      <TableCell className={classes.tableHeadingCell}>User Name</TableCell>
                      <TableCell className={classes.tableHeadingCell}>Streak</TableCell>
                      <TableCell className={classes.tableHeadingCell}>Ratings</TableCell>
                      <TableCell className={classes.tableHeadingCell}>Invitation Description</TableCell>
                      <TableCell className={classes.tableHeadingCell}>Pay Type</TableCell>
                      <TableCell className={classes.tableHeadingCell}>Start Date</TableCell>
                      <TableCell className={classes.tableHeadingCell}>End Date</TableCell>
                      <TableCell className={classes.tableHeadingCell}>Gig Hours</TableCell>
                      <TableCell className={classes.tableHeadingCell}>Amount ($)</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {hiredDetailsData?.length > 0 ? (
                      hiredDetailsData.map((user, index) => (
                        <TableRow className={classes.tableBodyRow} key={user._id}>
                          <TableCell className={classes.textMiddle}>
                            {index + 1 + rowsPerPage * (page - 1)}
                          </TableCell>
                          <TableCell className={classes.textMiddle}>
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "0.2rem" }}>
                              <div
                                style={{
                                  fontFamily: "Roboto",
                                  fontWeight: "400",
                                  fontSize: "14px",
                                  padding: "5px 16px",
                                  borderRadius: "31px",
                                  textTransform: "capitalize",
                                  color:
                                    get(user, "invitationHistory[0].statusNo") === "1"
                                      ? "#2CA63F"
                                      : get(user, "invitationHistory[0].statusNo") === "4" ||
                                        get(user, "invitationHistory[0].statusNo") === "6"
                                        ? "#FB5050"
                                        : get(user, "invitationHistory[0].statusNo") === "3"
                                          ? "#FDA517"
                                          : get(user, "invitationHistory[0].statusNo") === "2"
                                            ? "#FDA517"
                                            : get(user, "invitationHistory[0].statusNo") === "5"
                                              ? "#D2A800"
                                              : get(user, "invitationHistory[0].statusNo") === "7"
                                                ? "#5088FB"
                                                : get(user, "invitationHistory[0].statusNo") === "8"
                                                  ? "#5088FB"
                                                  : get(user, "invitationHistory[0].statusNo") === "9"
                                                    ? "#FDA517"
                                                    : "inherit",
                                  backgroundColor:
                                    get(user, "invitationHistory[0].statusNo") === "1"
                                      ? "#EAFFED"
                                      : get(user, "invitationHistory[0].statusNo") === "4" ||
                                        get(user, "invitationHistory[0].statusNo") === "6"
                                        ? "#FFEBED"
                                        : get(user, "invitationHistory[0].statusNo") === "3"
                                          ? "#FFF3E3"
                                          : get(user, "invitationHistory[0].statusNo") === "2"
                                            ? "#FFF3E3"
                                            : get(user, "invitationHistory[0].statusNo") === "5"
                                              ? "#FFFEE3"
                                              : get(user, "invitationHistory[0].statusNo") === "7"
                                                ? "#F3F3FF"
                                                : get(user, "invitationHistory[0].statusNo") === "8"
                                                  ? "#F3F3FF"
                                                  : get(user, "invitationHistory[0].statusNo") === "2"
                                                    ? "#FFF3E3"
                                                    : "transparent",
                                }}
                              >
                                {get(user, "hostStatus", "---")}
                              </div>
                            </div>
                          </TableCell>
                          <TableCell className={classes.textMiddle}>
                            {extractOnlyDate(get(user, "createdAt", "N/A"))}
                          </TableCell>
                          <TableCell className={classes.textMiddle}>
                            <div>
                              {get(user, "gigUserType", "---") === "host"
                                ? get(user, "workerDetails.userId", "---")
                                : get(user, "gigUserType", "---") === "worker"
                                  ? get(user, "hostDetails.userId", "---")
                                  : "---"}
                            </div>
                          </TableCell>
                          <TableCell className={classes.textMiddle}>
                            {/* <div>
                              {get(user, "gigUserType", "---") === "host"
                                ? get(user, "workerDetails.userName", "---")
                                : get(user, "gigUserType", "---") === "worker"
                                  ? get(user, "hostDetails.userName", "---")
                                  : "---"}
                            </div> */}
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: "0.5rem"
                              }}
                            >
                              <div>
                                <img src={medal} style={{ height: "1.5rem" }} />
                              </div>
                              <div style={{ textDecoration: "underline", color: "#5088FB" }}>
                                {get(user, "gigUserType") === "host"
                                  ? `${get(user, "workerDetails.userName", "---")} `
                                  : get(user, "gigUserType") === "worker"
                                    ? `${get(user, "hostDetails.userName", "---")} `
                                    : "Unknown"}
                              </div>
                            </div>
                          </TableCell>
                          <TableCell className={classes.textMiddle}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center"
                            }}>
                            <div className="container-Leader">
                              <img src={Fire} className="fire-img-Leader" />
                              <div className="center-text-Leader">{get(user, "workerStreakDetails.streakCount", "0")}</div>
                            </div>
                          </TableCell>
                          <TableCell className={classes.textMiddle}>

                            <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                              <div style={{
                                width: "41px",
                                height: "21px",
                                background: "#FFF4E7",
                                border: "0.75px solid #0000001F",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: "2px",
                                padding: "10px"

                              }}>

                                {Math.floor(Number(get(user, "workerFeedbackDetails.averageRating", 0)) * 10) / 10} <img src={Star} />
                              </div>
                            </div>
                          </TableCell>
                          <TableCell className={classes.textMiddle}>

                            {get(user, "invitationMsg", "---").length > 30
                              ? `${get(user, "invitationMsg", "---").slice(0, 30)}...`
                              : get(user, "invitationMsg", "---")}
                            <span style={{
                              color: "#29A4CA",
                              cursor: "pointer",
                              textDecoration: "underline"
                            }}
                              onClick={() => {
                                setDescription(true);
                              }}
                            >more</span>

                          </TableCell>
                          <TableCell className={classes.textMiddle}>
                            <div style={{ textTransform: "capitalize" }}>
                              {get(user, "gigDetails.gigPayType", "N/A")}
                            </div>

                          </TableCell>
                          <TableCell className={classes.textMiddle}>
                            <div>{extractOnlyDate(get(user, "gigDetails.startDate", "---"))}</div>
                          </TableCell>
                          <TableCell className={classes.textMiddle}>
                            <div>{extractOnlyDate(get(user, "gigDetails.endDate", "---"))}</div>
                          </TableCell>
                          <TableCell className={classes.textMiddle}>
                            {get(user, "gigDetails.totalGigHrsRequire") || "N/A"}
                          </TableCell>
                          <TableCell className={classes.textMiddle}>
                            <div>
                              {get(user, "gigDetails.hourlyAmount")
                                ? `${get(user, "gigDetails.hourlyAmount")} Per Hour`
                                : "N/A"}
                            </div>
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={9} align="center" style={{ padding: "2rem" }}>
                          <DashHeading style={{ textAlign: "center", color: "#000" }}>
                            No Data Found !!
                          </DashHeading>
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            )}


          </ProfileDetailForm>
        </DashboardWrapper>
      </DashboardContainer >




      {/* Popover for user info */}
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <Box sx={{ p: 1.5, width: "250px" }}>
          <div>
            <div className="user_info">User Info</div>
            <div style={{ display: "flex", flexDirection: "column", gap: "4px", marginTop: "10px" }}>
              <div style={{ display: "flex", gap: "8px", fontSize: "13px" }}>
                <div>
                  <div>User Name</div>
                  <div>Legal Name</div>
                  <div>Referral Code </div>
                  <div>Mobile Number </div>
                  <div>Date of Birth </div>
                </div>
                <div>
                  <div>:</div>
                  <div>:</div>
                  <div>:</div>
                  <div>:</div>
                  <div>:</div>
                </div>
                <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end" }}>
                  <div>{userInfo?.hostDetails?.userName}</div>
                  <div>{userInfo?.hostDetails?.firstName} {userInfo?.hostDetails?.lastName}</div>
                  <div>{userInfo?.hostDetails?.referralCode ?? "N/A"}</div>
                  <div>{userInfo?.hostDetails?.countryCode} {userInfo?.hostDetails?.phoneNumber}</div>
                  <div>{extractOnlyDate(userInfo?.hostDetails?.dateOfBirth) || "N/A"}</div>
                </div>
              </div>

            </div>
          </div>
        </Box>
      </Popover>


      {/* Modal for Block Gig  */}
      < Modal
        maxWidth="lg"
        width="360px"
        RoundedCorners={true}
        isOpen={blockModal}
        onClose={() => {
          setBlockModal(false);
        }}
        backgroundModal={false}
        backgroundModalContent={false}
        title={
          <div div >
            <div className="d-flex align-items-center justify-content-end">
              <RxCross2 style={{ cursor: "pointer" }} onClick={() => setBlockModal(false)} />
            </div>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", marginBottom: "10px" }}>
              <img src={block} style={{ height: "3.5rem" }} />
            </div>
            <div className="block-header" style={{ textAlign: "center" }}>Are you sure you want to block this gig ?</div>

          </div >
        }
        content={
          <>
            <div className="logout-button-group">
              <div
                className="cancel-button"
                onClick={() => {
                  setBlockModal(false);
                }}
              >
                Cancel
              </div>
              <div
                className="logout-button"
                style={{ background: "#5588FB", cursor: "pointer" }}
                onClick={() => {
                  setBlockModal(false);
                  blockUnblock();
                }}
              >
                Yes
              </div>
            </div>
          </>
        }
      />


      {/* Modal for UnBlock Gig  */}
      < Modal
        maxWidth="lg"
        width="360px"
        RoundedCorners={true}
        isOpen={unBlockModal}
        onClose={() => {
          setUnBlockModal(false);
        }}
        backgroundModal={false}
        backgroundModalContent={false}
        title={
          <div div >
            <div className="d-flex align-items-center justify-content-end">
              <RxCross2 style={{ cursor: "pointer" }} onClick={() => setUnBlockModal(false)} />
            </div>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", marginBottom: "10px" }}>
              <img src={unblock} style={{ height: "3.5rem" }} />
            </div>
            <div className="block-header" style={{ textAlign: "center" }}>Are you sure you want to Unblock this Gig ?</div>

          </div >
        }
        content={
          <>
            <div className="logout-button-group">
              <div
                className="cancel-button"
                onClick={() => {
                  setUnBlockModal(false);
                }}
              >
                Cancel
              </div>
              <div
                className="logout-button"
                style={{ background: "#5588FB", cursor: "pointer" }}
                onClick={() => {
                  setUnBlockModal(false);
                  blockUnblock(); // ← Use selectedGigId here

                }}

              >
                Yes
              </div>

            </div>
          </>
        }
      />


      {/* Modal for Description */}
      < Modal
        maxWidth="lg"
        width="420px"
        RoundedCorners={true}
        isOpen={description}
        onClose={() => {
          setDescription(false);
        }}
        backgroundModal={false}
        backgroundModalContent={false}

        title={
          <div >
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>

              <div className="Model_heading_Data">
                {userDetails?.gigUserType === "worker"
                  ? "Invitation Received"
                  : userDetails?.gigUserType === "host"
                    ? "Proposal Received"
                    : ""}
              </div>
              <div><RxCross2 style={{ cursor: "pointer" }} onClick={() => setDescription(false)} /></div>
            </div>
            {selectedUser ? (
              <div style={{ marginTop: "1rem" }}>

                {userDetails?.gigUserType === "worker" ? (
                  <div
                    style={{
                      display: "flex",
                      gap: "1.5rem",
                      fontSize: "14px",
                      fontWeight: "400",
                      justifyContent: "space-between"
                    }}
                  >
                    <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
                      <div className="Model_Data_text">Start Date</div>
                      <div className="Model_Data_text">Hourly Amount</div>
                      <div className="Model_Data_text">Total Gig Hours Requirement</div>
                      <div className="Model_Data_text">Zip Code</div>
                    </div>
                    <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
                      <div className="Model_Data_text">:</div>
                      <div className="Model_Data_text">:</div>
                      <div className="Model_Data_text">:</div>
                      <div className="Model_Data_text">:</div>
                    </div>
                    <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
                      <div className="Model_Data_text">{extractOnlyDate(selectedUser?.startDate)}</div>
                      <div className="Model_Data_text">{selectedUser?.hourlyAmount ?? "N/A"}</div>
                      <div className="Model_Data_text">{selectedUser?.totalGigHrsRequire ?? "N/A"}</div>
                      <div className="Model_Data_text">{selectedUser?.zipCode ?? "N/A"}</div>
                    </div>
                  </div>
                ) : userDetails?.gigUserType === "host" ? (
                  <div
                    style={{
                      display: "flex",
                      gap: "1.5rem",
                      fontSize: "14px",
                      fontWeight: "400",
                      justifyContent: "space-between"
                    }}
                  >
                    <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
                      <div className="Model_Data_text">Experience</div>
                      <div className="Model_Data_text">Skills</div>
                      {/* <div className="Model_Data_text">Certificates</div> */}
                    </div>
                    <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
                      <div className="Model_Data_text">:</div>
                      <div className="Model_Data_text">:</div>
                      {/* <div className="Model_Data_text">:</div> */}

                    </div>
                    <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
                      <div className="Model_Data_text"><span>
                        {selectedUser?.totalExperience
                          ? Math.floor(selectedUser.totalExperience / 12) > 0
                            ? `${Math.floor(selectedUser.totalExperience / 12)} year${Math.floor(selectedUser.totalExperience / 12) !== 1 ? 's' : ''} 
                       ${selectedUser.totalExperience % 12} month${selectedUser.totalExperience % 12 !== 1 ? 's' : ''}`
                            : `${selectedUser.totalExperience % 12} month${selectedUser.totalExperience % 12 !== 1 ? 's' : ''}`
                          : 'N/A'}
                      </span></div>
                      {/* <div className="Model_Data_text">{selectedUser?.skillRequired ?? "N/A"}</div> */}
                      <div style={{ display: "flex", gap: "0.5rem", flexWrap: "wrap" }}>
                        {selectedUser?.skillRequired?.length > 0 ? (
                          selectedUser?.skillRequired.map((skill, index) => (
                            <div className="skill-item-Data_model" key={index}>{skill}</div>
                          ))
                        ) : (
                          <p>No skills available</p>
                        )}
                      </div>

                      {/* <div className="Model_Data_text">{selectedUser?.zipCode ?? "N/A"}</div> */}
                    </div>
                  </div>

                ) : null}

                <div style={{ display: "flex", marginTop: "0.8rem", justifyContent: "space-between" }}>
                  <div className="Model_Data_text">Certificates</div>
                  <div className="Model_Data_text" style={{ marginLeft: "1.2rem", marginRight: "1.5rem" }}>:</div>
                  <div style={{ display: "flex", gap: "0.5rem", flexWrap: "wrap" }}>
                    {selectedUser?.certificatesData?.length > 0 ? (
                      selectedUser.certificatesData.map((certificate, index) => (
                        <div className="certificate_Formate" key={index}>
                          <div>
                            <img src={certificate.uploadCertificate} style={{ height: "2rem", width: "3rem" }} />
                          </div>
                          <div style={{ display: "flex", flexDirection: "column", gap: "0.3rem" }}>
                            <div className="certificate_Formate_Name">{certificate.certificateName}</div>
                            <div className="certificate_Formate_issue">{certificate.issueBy}</div>
                          </div>
                        </div>
                      ))
                    ) : (
                      <p>No Certificate available</p>
                    )}
                  </div>
                </div>

                <div style={{ marginTop: "1.5rem" }}>
                  <div className="gigDescriptionHeading">Gig Description</div>
                  <div className="data_description_modal">
                    {selectedUser?.invitationMsg || "No description provided"}
                  </div>
                </div>
              </div>
            ) : (
              <div>No user info available.</div>
            )}
          </div >
        }
        content={
          <>

          </>
        }
      />


      {/* Modal for Status */}
      < Modal
        maxWidth="lg"
        width="310px"
        RoundedCorners={true}
        isOpen={statusData}
        onClose={() => {
          setStatusData(false);
        }}
        backgroundModal={false}
        backgroundModalContent={false}

        title={
          <div >
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <div className="walk_data">{userDetails?.gigUserType} Gig Walk Through</div>
              <div><RxCross2 style={{ cursor: "pointer" }} onClick={() => setStatusData(false)} /></div>
            </div>
            <div style={{ marginTop: "1rem" }}>

              <div className="stepper-container">
                {(statusHistryData) && statusHistryData.length > 0 ? (
                  statusHistryData.map((data, index) => (
                    <div className="stepper-item" key={index}>
                      <div className="stepper-line" />
                      <div className="stepper-dot" />
                      <div className="stepper-content">
                        <div className="stepper-status"
                          style={{
                            color:
                              data.statusNo == "4"
                                ? "#FB5050"
                                : data.statusNo == "1"
                                  ? "#2CA63F"
                                  : data.statusNo == "7"
                                    ? "#5088FB"
                                    : data.statusNo == "2"
                                      ? "#FDA517"
                                      : data.statusNo == "3"
                                        ? "#FDA517"
                                        : data.statusNo == "5"
                                          ? "#D2A800"
                                          : data.statusNo == "6"
                                            ? "#FB5050"
                                            : data.statusNo == "8"
                                              ? "#D2A800"
                                              : data.statusNo == "9"
                                                ? "#2CA63F"
                                                : "inherit",
                          }}
                        >{data.status}</div>
                        <div className="stepper-date">
                          {extractDate(get(data, "invitationDate"))}
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="no-data">No data available</div>
                )}
              </div>



            </div>
          </div >
        }
        content={
          <>

          </>
        }
      />


      < Modal
        maxWidth="lg"
        width="370px"
        RoundedCorners={true}
        isOpen={paymentModal}
        onClose={() => {
          setPaymentModal(false);
        }}
        backgroundModal={false}
        backgroundModalContent={false}
        title={
          <div div >
            <div className="d-flex align-items-center justify-content-end">
              <RxCross2 style={{ cursor: "pointer" }} onClick={() => setPaymentModal(false)} />
            </div>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", marginBottom: "10px" }}>
              <img src={Check} style={{ height: "4.5rem" }} />
            </div>
            <div  style={{ textAlign: "center",
              fontSize: "18px",
              color: "#1818181",
              fontWeight: 700
             }}>Payment Successful!</div>
            <div style={{ textAlign: "center" ,
            color: "#484848",
            fontSize: "16px",
            fontWeight: 400

            }}>Thank you for your payment. Your transaction has been completed successfully</div>

            <div onClick={() => setPaymentModal(false)} style={{background: "#5088FB", cursor: "pointer", borderRadius: "4px", color: "#FFFFFF", textAlign: "center", padding: "5px", marginTop: "1rem"}}
            >Okay</div>

          </div >
        }
        content={
          <>
            {/* <div className="logout-button-group">
             
            </div> */}
          </>
        }
      />


      {isLoading && <Overlay />}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    userData: state.userData,
    locationData: state.locations,
    defaultState: state.defaultState,
    sidebar: state.sidebar,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setUsers: (updatedValue) => {
      dispatch({
        type: actionTypes.UPDATE_USER,
        updatedUser: updatedValue,
      });
    },
    setDefaultState: (updatedValue) => {
      dispatch({
        type: actionTypes.UPDATE_DEFAULT,
        updateDefault: updatedValue,
      });
    },
    setSidebar: (updatedValue) => {
      dispatch({
        type: actionTypes.UPDATE_SIDEBAR,
        updateSidebar: updatedValue,
      });
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GigOverview);


